export default __webpack_public_path__ + "static/media/Thumbs.ae27b489.db";